module.exports = __webpack_public_path__ + "assets/img/ca-joins-ludimos.61b79a43.jpg";